// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Rxjs from "rxjs";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function $$void(param) {
  
}

function make(next, error, complete, param) {
  return {
    next: next,
    error: error,
    complete: complete
  };
}

let Observer = {
  make: make
};

let Subscriber = {};

let Observable = {};

let Subject = {};

let BehaviorSubject = {};

let ReplaySubject = {};

function $$const(b) {
  return Rxjs.map((param, param$1) => b);
}

function op(xs, operator) {
  return operator(xs);
}

function keepSome(xs) {
  return Rxjs.map((a, param) => Stdlib_Option.getOrThrow(a, undefined))(Rxjs.filter(Stdlib_Option.isSome)(xs));
}

function keepMap(f) {
  return xs => keepSome(Rxjs.map((a, param) => f(a))(xs));
}

function distinctBy(fn) {
  return source => new Rxjs.Observable(subscriber => {
    let last = {
      contents: undefined
    };
    let sub = source.subscribe({
      next: x => {
        let fnx = fn(x);
        if (Primitive_object.notequal(Primitive_option.some(fnx), last.contents)) {
          last.contents = Primitive_option.some(fnx);
          subscriber.next(x);
          return;
        }
      },
      error: e => {
        subscriber.error(e);
      },
      complete: () => {
        subscriber.complete();
      }
    });
    return () => {
      sub.unsubscribe();
    };
  });
}

export {
  $$void,
  Observer,
  Subscriber,
  Observable,
  Subject,
  BehaviorSubject,
  ReplaySubject,
  $$const,
  op,
  keepSome,
  keepMap,
  distinctBy,
}
/* rxjs Not a pure module */
